import React from 'react';
import { LockIcon, PackageCheckIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { checkoutTrust, paymentMethods, shippingCarriers } from '../../data/shopify';
import { freeShippingLive } from '../../data/pricing';
import { useLanguage } from '../../contexts/LanguageContext';
import { BrandLogo } from './BrandLogo';

/** Accepted payment methods + shipping carrier, shown beside every checkout CTA. */
export function PaymentTrust({
  className = ''
}: {
  className?: string;
}) {
  const {
    t,
    lang
  } = useLanguage();
  const es = lang === 'es';
  const methods = paymentMethods.filter(m => m.enabled);
  return <div className={`grid gap-6 md:grid-cols-[1.6fr_1fr] md:gap-10 ${className}`} data-id="element-867" data-mp="4r232w8u5r9j">
      <div data-id="element-868" data-mp="9o20kirmdlp1">
        <p className="flex items-center gap-2 text-xs font-medium uppercase tracking-[0.12em] text-titanium" data-id="element-869" data-mp="9olhbw5ja41h">
          <LockIcon className="h-3.5 w-3.5 text-marine" aria-hidden data-id="element-870" data-mp="emd8up29no55" />
          {t('trust.secure')} {checkoutTrust.provider}
        </p>
        <ul className="mt-3 flex flex-wrap gap-1.5" aria-label={es ? 'Métodos de pago aceptados' : 'Accepted payment methods'} data-id="element-871" data-mp="2twk88qnn8qir">
          {methods.map(m => <li key={m.id} data-id="element-872" data-mp="2oz0wpyibyrui">
              <BrandLogo src={m.icon} label={m.label} data-id="element-873" data-mp="2jxl7rvd1816u" />
            </li>)}
        </ul>
      </div>

      <div data-id="element-874" data-mp="2ez9z3nyh3wq7">
        <p className="flex items-center gap-2 text-xs font-medium uppercase tracking-[0.12em] text-titanium" data-id="element-875" data-mp="2ezjszmmn2o16">
          <PackageCheckIcon className="h-3.5 w-3.5 text-marine" aria-hidden data-id="element-876" data-mp="3clh614i9215q" />
          {es ? 'Envío' : 'Shipping'}
        </p>
        <div className="mt-3 flex items-center gap-3" data-id="element-877" data-mp="37o7f1kf7phfs">
          {shippingCarriers.map(c => <BrandLogo key={c.id} src={c.logo} label={c.label} className="h-7 w-[104px] bg-white px-1.5 py-1" data-id="element-878" data-mp="32uwajpxvhcr1" />)}
          <p className="text-xs leading-snug text-titanium" data-id="element-879" data-mp="3vd04cy1bwr1f">
            {freeShippingLive() ? es ? 'Envío estándar gratis en EE.UU. continental' : 'Free standard shipping, contiguous U.S.' : es ? 'Envío por USPS · tarifa calculada al pagar' : 'Ships via USPS · rates calculated at checkout'}
            <br data-id="element-880" data-mp="1tpxcft92fenu" />
            {es ? 'Número de rastreo por correo. ' : 'Tracking number emailed. '}
            <Link to="/shipping" className="underline decoration-white/20 underline-offset-2 hover:text-white" data-id="element-881" data-mp="1ex3u802eskfh">
              {es ? 'Política de envío' : 'Shipping policy'}
            </Link>
          </p>
        </div>
      </div>
    </div>;
}